module.exports = __webpack_public_path__ + "static/sun_dam-b927b96be2d1d12b5ca1aa5cc44e0147.png";